import { render } from "./CookieConsentPopup.vue?vue&type=template&id=fca30150&scoped=true"
import script from "./CookieConsentPopup.vue?vue&type=script&lang=js"
export * from "./CookieConsentPopup.vue?vue&type=script&lang=js"

import "./CookieConsentPopup.vue?vue&type=style&index=0&id=fca30150&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fca30150"]])

export default __exports__